var map = {
	"./BENVENISTE-white.png": 428,
	"./BENVENISTE_logo-black.png": 878,
	"./BENVENISTE_logo-white.png": 208,
	"./BVLogo-Small [H-500].png": 332,
	"./BVLogo-Small-2.png": 401,
	"./BurgerMenuIconBlack.png": 889,
	"./BurgerMenuIconBlack2.png": 903,
	"./BurgerMenuIconWhite.png": 611,
	"./BurgerMenuIconWhite2.png": 561,
	"./CONTEMPORARY-white.png": 190,
	"./FinalBCLogoBlack.png": 698,
	"./FinalBCLogoBlack2.png": 930,
	"./FinalBCLogoBlack3.png": 35,
	"./FinalBCLogoWhite.png": 116,
	"./FinalBCLogoWhite2.png": 436,
	"./FinalBCLogoWhite3.png": 349,
	"./Logo NB.png": 888,
	"./NewBlackBenvLogoCropped.png": 993,
	"./NewWhiteBenvLogoCropped.png": 547,
	"./PSC-Logo-black.png": 723,
	"./PSC-Logo-grey.png": 725,
	"./PSC-Logo-white.png": 909,
	"./ifpda - artemadrid - consorcio.png": 223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 171;